interface SEOHeadProps {
  title: string;
  description: string;
  keywords: string;
  canonicalUrl?: string;
  ogType?: string;
  ogImage?: string;
  schema?: Record<string, unknown> | Record<string, unknown>[];
}

export default function SEOHead({ title, description, keywords, canonicalUrl, ogType = 'website', ogImage, schema }: SEOHeadProps) {
  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}

      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={ogType} />
      <meta property="og:site_name" content="17吃瓜" />
      <meta property="og:locale" content="zh_CN" />
      {canonicalUrl && <meta property="og:url" content={canonicalUrl} />}
      {ogImage && <meta property="og:image" content={ogImage} />}

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {ogImage && <meta name="twitter:image" content={ogImage} />}

      {schema && (
        Array.isArray(schema) ? (
          schema.map((s, i) => (
            <script key={i} type="application/ld+json">{JSON.stringify(s)}</script>
          ))
        ) : (
          <script type="application/ld+json">{JSON.stringify(schema)}</script>
        )
      )}
    </>
  );
}